<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-image-filter-black-white"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1 mt-2">
        <v-col cols="12" class="white p-5 ">
          <v-col cols="6">
            <div class="mb-2">Name<span class="necessary">(*)</span></div>
            <div class="d-flex">
              <v-text-field
                  id="name"
                  v-model="template.name"
                  placeholder="Enter the name of the image"
                  filled
              >
              </v-text-field>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="mb-2">Themes</div>
            <v-select
                v-model="list_theme_id"
                :items="list_theme"
                item-text="name"
                item-value="id"
                filled
                placeholder="Choose the theme of the template"
                chips
                multiple
            ></v-select>
          </v-col>
          <v-col cols="6">
            <div class="mb-2">Tags</div>
            <v-select
                v-model="list_tag_id"
                :items="list_tag"
                item-text="name"
                item-value="id"
                filled
                placeholder="Choose the tag of the template"
                chips
                multiple
            ></v-select>
          </v-col>
          <v-col cols="12" class="text-center mb-5 mt-1">
            <v-btn
                class="btn-add-templates"
                @click="addTemplate"
            >
              Add Templates
            </v-btn>
          </v-col>
        </v-col>

      </v-row>
    </v-container>
  </div>
</template>

<script>
import {SAVE_TEMPLATE} from "@/store/modules/template";
import {GET_LIST_TEMPLATE_SIZE} from "@/store/modules/template_size";
import {mapGetters} from "vuex";
import {GET_LIST_TEMPLATE_THEMES} from "@/store/modules/themes";
import {GET_LIST_TAGS} from "@/store/modules/tags";

export default {
  name: "AddTemplate",
  data() {
    return {
      page: "Templates",
      breadcrumbs: [
        {
          text: "Templates Setting",
          disabled: true,
        },
        {
          text: "Templates",
          disabled: false,
          href: '/template_setting/templates',
        },
        {
          text: "Add Template",
          disabled: false,
        },
      ],
      upload_designs: [],
      template: {
        name: '',
        theme_id: [],
        tag_id: [],
      },
      list_theme: [],
      list_theme_id: [],
      list_tag: [],
      list_tag_id: [],
      pattern: /\D/g,
    }
  },
  computed: {
    ...mapGetters({
      listTemplateSize: "listTemplateSize",
      listThemes: "listThemes",
      tags: "tags",
    })
  },
  async created() {
    await this.$store.dispatch(GET_LIST_TEMPLATE_SIZE);
    await this.$store.dispatch(GET_LIST_TEMPLATE_THEMES);
    await this.$store.dispatch(GET_LIST_TAGS);
  },
  watch: {
    listThemes(val) {
      if (val) {
        const _this = this
        val.forEach(el => {
          _this.list_theme.push({
            id: el.id,
            name: el.name,
          })
        })
      }

    },
    tags(val) {
      if (val) {
        const _this = this
        val.forEach(el => {
          _this.list_tag.push({
            id: el.id,
            name: el.name,
          })
        })
      }
    },

  },
  methods: {
    async addTemplate() {
      if (this.template.name == '') {
        alert("Name is empty!");
        return;
      } else {
        const _this = this
        this.list_theme_id.forEach(id => {
          let tag = this.list_theme.find(el => el.id == id)
          _this.template.theme_id.push(tag.id
          )
        })
        this.list_tag_id.forEach(id => {
          let tags = this.list_tag.find(el => el.id == id)
          _this.template.tag_id.push(tags.id
          )
        })
        let data = {
          name: this.template.name,
          theme: JSON.stringify(this.template.theme_id),
          tags: JSON.stringify(this.template.tag_id)
        }
        await this.$store.dispatch(`${SAVE_TEMPLATE}`, data).then((data) => {
              if (data.data.status == 1) {
                this.$toasted.success('Update successful!', {
                  duration: 1000,
                  position: 'top-center'
                })
                this.$router.push('/template_setting/templates')
              } else {
                alert(data.data.errors)
              }
            }
        )
        ;

      }

    }
  }
}
</script>

<style scoped>
.necessary {
  color: red;
  margin-left: 2px;
}

.drag-drop {
  border: 0.5px dashed #949494;
  border-radius: 6px;
  height: 200px;
  width: 100%;
  position: relative;
}

.icon {
  color: #71BEC8;
}

.drag-drop-gird {
  width: 100%;
  height: 100%
}

.dropZone {
  width: 100%;
  height: 100%;
  position: relative;
}

.dropZone-info {
  color: #696969;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #71BEC8;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}


.dropZone-uploaded {
  width: 100%;
  height: 100%;
  position: relative;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}
</style>